import { render, staticRenderFns } from "./RelatorioPedidos.vue?vue&type=template&id=f6046ff0"
import script from "./RelatorioPedidos.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports